
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertCircle, Search } from "lucide-react";
import { useTranslation } from "react-i18next";

interface FavoritesEmptyProps {
  type: "no-favorites" | "no-search-results";
  onClearSearch?: () => void;
}

export const FavoritesEmpty = ({ type, onClearSearch }: FavoritesEmptyProps) => {
  const { t } = useTranslation('common');
  
  if (type === "no-favorites") {
    return (
      <div className="flex flex-col items-center justify-center rounded-md border border-brand-cloud bg-white p-8 text-center shadow-sm md:p-10">
        <AlertCircle className="mb-4 h-12 w-12 text-brand-slate" />
        <h3 className="mb-2 public-card-title">{t("favorites.noFavorites.title")}</h3>
        <p className="mb-6 text-brand-slate">
          {t("favorites.noFavorites.description")}
        </p>
        <Link to="/explore" className="mt-2">
          <Button className="bg-brand-ink text-white hover:bg-brand-charcoal">
            {t("favorites.noFavorites.button")}
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl rounded-md border border-brand-cloud bg-white p-8 text-center shadow-sm md:p-10">
      <div className="flex justify-center mb-4">
        <Search className="h-12 w-12 text-brand-slate" />
      </div>
      <h2 className="mb-2 public-card-title">{t("favorites.noSearchResults.title")}</h2>
      <p className="mb-6 text-brand-slate">
        {t("favorites.noSearchResults.description")}
      </p>
      <Button 
        variant="outline" 
        onClick={onClearSearch}
        className="mt-2"
      >
        {t("favorites.noSearchResults.button")}
      </Button>
    </div>
  );
};
